module.exports = __webpack_public_path__ + "media/images/TAK_featured_img_1200x627-09b6a53c0abe9656325b1fd27f033b5d.jpg";